<template>
    <div
        class="slt-max-content-center relative h-[460px] w-full overflow-hidden bg-base-silver px-6 pt-[102px] sm:px-[var(--padding-sm)] sm:pt-[120px] lg:h-[400px] lg:rounded-[2rem] lg:px-[min(10vw,200px)] lg:pb-[168px] lg:pt-[172px]"
    >
        <div
            class="absolute left-0 top-0 h-full w-full rotate-[-15deg] font-en text-[22vw]/[.95] font-bold tracking-tighter text-[#E2E6ED] sm:rotate-[-10deg] sm:text-[14vw]/[.95] lg:rotate-0 lg:text-[9vw] 3xl:text-[170px]"
        >
            <div
                class="flex h-full translate-y-[10%] flex-col justify-center sm:translate-y-[-10%] lg:translate-y-0 lg:justify-between"
            >
                <div
                    v-for="i in 2"
                    :key="i"
                    class="flex gap-x-[5vw]"
                    :class="
                        i === 2
                            ? '-translate-x-[70%] lg:translate-y-[31%]'
                            : 'lg:translate-y-[-31%]'
                    "
                >
                    <span v-for="i in 5" :key="i" v-if="shouldRender(marquee)">
                        {{ marquee }}
                    </span>
                </div>
            </div>
        </div>
        <ClientOnly>
            <!-- Dynamic Lottie -->
            <LottieAnimation
                v-if="currentLottie"
                :key="screenSize"
                :animationData="currentLottie"
                class="absolute inset-0 w-full"
                :class="{
                    'hidden h-auto lg:block': screenSize === 'lg',
                    'hidden h-auto sm:block lg:hidden': screenSize === 'md',
                    'h-auto sm:hidden': screenSize === 'sm'
                }"
            />
        </ClientOnly>
        <AtomsH2
            class="relative text-left sm:absolute sm:bottom-10 sm:left-[var(--padding-sm)] lg:relative lg:bottom-[unset] lg:left-[unset]"
            v-if="shouldRender(title)"
        >
            <BaseFormatText2 ref="titleText" :text="title" type="span" />
        </AtomsH2>
    </div>
</template>

<script setup>
import { shouldRender } from "~/lib/utils";
import { textSplitAnimate } from "~/lib/gsap-core";
import { useResponsiveLottie } from "@/composables/useResponsiveLottie";

const { title, marquee } = defineProps({
    title: {
        type: [Array, String],
        required: true,
    },
    marquee: {
        type: String,
        required: true,
    },
});

const { isLoading } = useAppState();

const { current: currentLottie, load: loadLottie, screenSize } = useResponsiveLottie({
    sm: () => import("@/assets/lottie/banner/news/_m.json"),
    md: () => import("@/assets/lottie/banner/news/_t.json"),
    lg: () => import("@/assets/lottie/banner/news/_d.json"),
});

const titleText = ref(null);

onMounted(() => {
    loadLottie();
    watch(isLoading, (newVal) => {
        textSplitAnimate(newVal, titleText);
    });
});
</script>

<style scoped>
.marquee-container {
    @apply pointer-events-none absolute inset-0 w-full;
}

.marquee {
    @apply relative w-[200%] whitespace-nowrap uppercase lg:absolute;
}
</style>
